import { useState } from "react";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { CreateSavedViewSaveModel } from "../SavedViewsMenu.types";
import { CreateSavedViewDialogProps } from "./CreateSavedViewDialog.tsx";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { isNullOrWhitespace } from "../../../stringOperations.ts";
import { post } from "../../../api/apiShared.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useCreateSavedViewHook(props: CreateSavedViewDialogProps) {
    const snackbar = useDotLegalSnackbar();

    const { translateString } = useTranslation();

    const [saveModel, setSaveModel] = useState<CreateSavedViewSaveModel>({
        name: "",
        savedViewType: props.savedViewType,
        filterConfiguration: props.filterConfiguration,
        displayConfiguration: props.displayConfiguration,
        isGlobal: false,
        isCustomerDefault: false,
        scopeId: props.scopeId,
        secondaryScopeId: props.secondaryScopeId,
    });
    const [showError, setShowError] = useState(false);

    const updater = {
        onNameChange: (name: string) => {
            let tempModel = { ...saveModel };
            tempModel.name = name;
            setSaveModel(tempModel);
        },
        onIsGlobalChange: (isGlobal: boolean) => {
            let tempModel = { ...saveModel };
            tempModel.isGlobal = isGlobal;
            setSaveModel(tempModel);
        },
        onIsCustomerDefaultChange: (isCustomerDefault: boolean) => {
            let tempModel = { ...saveModel };
            tempModel.isCustomerDefault = isCustomerDefault;
            if (!tempModel.isGlobal) {
                tempModel.isGlobal = true;
            }
            setSaveModel(tempModel);
        },
    };

    const createMutation = useDotLegalMutation(create);

    const onCreateView = () => {
        if (isNullOrWhitespace(saveModel.name)) {
            setShowError(true);
            return;
        }

        createMutation.mutateAsync(saveModel, {
            onSuccess: (response: any) => {
                snackbar.show(translateString("savedViewCreated"));
                props.onViewSaved(response.value().id);
            },
        });
    };

    return {
        saveModel,
        updater,
        showError,
        onCreateView,
        inProgress: createMutation.isLoading,
    };

    async function create(saveModel: CreateSavedViewSaveModel) {
        return await post<string>("/saved-views", saveModel);
    }
}
